import React from "react"
import { useLocation } from "react-router-dom"
import { EventAdminDashboardPage } from "./event/EventAdminDashboardPage"
import { AppAdminDashboardPage } from "./app/AppAdminDashboardPage"
import { useAdminAuth } from "../../hooks/useAdminAuth"

export const AdminDashboardPage = () => {
  const location = useLocation()
  const authUser = useAdminAuth()

  if (authUser()?.type === "eventAdmin") {
    return (
      <EventAdminDashboardPage notification={location.state?.notification} />
    )
  } else if (authUser()?.type === "appAdmin") {
    return <AppAdminDashboardPage notification={location.state?.notification} />
  }

  return null
}
